import { useState, useEffect } from 'react';
import Logo from './Logo';

export default function Header() {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleLogoClick = (e) => {
    if (window.location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.getElementById('hero');
      if (heroSection) {
        const heroSectionBottom = heroSection.offsetTop + heroSection.offsetHeight;
        if (window.scrollY > heroSectionBottom - 400) {
          setIsExpanded(true);
        } else {
          setIsExpanded(false);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className="header py-4">
      <div className="container mx-auto px-6 flex items-center justify-between">
          <a href="/" onClick={handleLogoClick}>
            <Logo />
          </a>
        <div className="flex items-center space-x-4">
          <a href="https://editor.takeoff.careers" className="btn-secondary text-sm">
            LOG IN
          </a>
          <a 
            href="https://editor.takeoff.careers/sign-up" 
            className={`header-cta btn-secondary text-sm ${isExpanded ? 'expanded' : ''}`}
          >
            <span className="initial-text">SIGN UP</span>
            <span className="expanded-text">
              GET STARTED<span className="ml-2">→</span>
            </span>
          </a>
        </div>
      </div>
    </header>
  );
}
